
import { call } from 'vuex-pathify'

export default {
  name: 'CompareProductCard',
  inheritAttrs: false,
  props: {
    product: {
      type: Object,
      default: null
    },
    primary: {
      type: Object,
      default: null
    }
  },
  vessel: {
    card: {
      $attrs: 'all'
    },
    icon: {
      cursor: 'pointer',
      fontSize: 'xl',
      padding: '2xs',
      color: 'grey-darker',
    },
    remove: {
      $extend: 'icon',
      color: 'danger'
    },
    title: {
      fontSize: 'md',
      textAlign: 'center'
    },
    prevPrice: {
      fontSize: 'sm',
      color: 'grey-dark'
    },
    price: {
      fontSize: 'md',
      fontWeight: 'bold'
    }
  },
  computed: {
    cartEnabled() {
      return this.$cart != null
    },
    isPrimary() {
      return this.product.id == this.primary.id
    },
    priceIcon() {
      const isLower = this.product.salePrice.value < this.primary.salePrice.value
      const isEqual = this.product.salePrice.value == this.primary.salePrice.value
      const upper = { name: 'arrow-up', color: 'danger' }
      const lower = { name: 'arrow-down', color: 'success' }
      const equal = { name: 'minus', color: 'grey' }

      if (isEqual) {
        return equal
      }

      return isLower ? lower : upper
    }
  },
  methods: {
    setPrimary: call('productCompare/setPrimary'),
    onClick() {
      this.setPrimary(this.product.id)
      this.$emit('set-primary')
    }
  }
}
